/**
 * Floating scroll-to-top / scroll-to-bottom control.
 *
 * Reveals the control (rendered by inc/scroll-control.php) only on pages tall
 * enough to be worth jumping around — useful for the long feeds produced by
 * infinite scroll. Smooth-scrolls to the top or bottom on click.
 */

const SHOW_AFTER = 1.5; // Show once the page is at least 1.5x the viewport tall.

/**
 * Wire up the control: reveal/hide on resize + scroll, scroll on click.
 */
export function initScrollControl() {
	const control = document.querySelector( '[data-whf-scroll-control]' );
	if ( ! control ) {
		return;
	}

	const prefersReduced = window.matchMedia(
		'(prefers-reduced-motion: reduce)'
	).matches;

	const isLongPage = () =>
		document.documentElement.scrollHeight >
		window.innerHeight * SHOW_AFTER;

	const setVisible = ( visible ) => {
		control.classList.toggle( 'is-hidden', ! visible );
		if ( visible ) {
			control.removeAttribute( 'hidden' );
		} else {
			control.setAttribute( 'hidden', '' );
		}
	};

	// Recompute on scroll/resize (throttled via rAF). The page height changes
	// as infinite scroll appends results, so we re-check continuously.
	let ticking = false;
	const update = () => {
		ticking = false;
		setVisible( isLongPage() );
	};
	const onChange = () => {
		if ( ! ticking ) {
			ticking = true;
			window.requestAnimationFrame( update );
		}
	};

	const scrollTo = ( position ) => {
		const top = position === 'bottom'
			? document.documentElement.scrollHeight
			: 0;
		window.scrollTo( {
			top,
			behavior: prefersReduced ? 'auto' : 'smooth',
		} );
	};

	control.addEventListener( 'click', ( event ) => {
		const btn = event.target.closest( '[data-scroll]' );
		if ( ! btn ) {
			return;
		}
		scrollTo( btn.getAttribute( 'data-scroll' ) );
	} );

	window.addEventListener( 'scroll', onChange, { passive: true } );
	window.addEventListener( 'resize', onChange, { passive: true } );
	// FacetWP swaps the results in (infinite scroll / pagination) which changes
	// page height without a scroll/resize event — re-check after each load.
	document.addEventListener( 'facetwp-loaded', onChange );

	update();
}
